import React from 'react';
import withIcon from '../utilities/withIcon';

const IconGrid = () => {
  return (
    <g>
      <path d="m1.05 0 13.901.017c.541 0 .986.41 1.043.936l.006.114V14.95c0 .541-.41.987-.936 1.044L14.95 16H1.05a1.05 1.05 0 0 1-1.044-.936L0 14.95V1.05C0 .51.41.064.936.007L1.051 0zm3.7 11.25H1.5v3.25h3.25v-3.25zm5 0h-3.5v3.25h3.5v-3.25zm4.75 0h-3.25v3.25h3.25v-3.25zM4.75 6.253H1.5V9.75h3.25V6.254zm5 0h-3.5V9.75h3.5V6.254zm4.75 0h-3.25V9.75h3.25V6.254zm-13-4.753v3.253h3.25v-3.25L1.5 1.501zm4.75.004v3.25h3.5V1.508l-3.5-.004zm5 .006v3.243h3.25V1.516l-3.25-.005z" />
    </g>
  );
};

export default withIcon(IconGrid);
